module.exports = __webpack_public_path__ + "img/joongang-ci.ed22d71b.png";